module.exports = __webpack_public_path__ + "img/scan.af62bc33.svg";